import {A11yControls} from "./application/A11yControls";
import {CardsCoverImageSlider} from "./application/blocks/CardsCoverImageSlider";
import {CardsScrollContainer} from "./application/blocks/CardsScrollContainer";
import {CardsSlider} from "./application/blocks/CardsSlider";
import {ServiceWheel} from "./application/blocks/ServiceWheel";
import {StepsSlider} from "./application/blocks/StepsSlider";
import {TestimonialsSlider} from "./application/blocks/TestimonialsSlider";
import {initAccordionBlocks} from "./application/blocks/wv-accordion";
import {initAnimatedTextsBlocks} from "./application/blocks/wv-animated-texts";
import {initCounterBlocks} from "./application/blocks/wv-counter";
import {initNavigatedContentBlocks} from "./application/blocks/wv-navigated-content";
import {initPostsTeasers} from "./application/blocks/wv-posts-teaser";
import {initVideoBlocks} from "./application/blocks/wv-video";
import {initLinks} from "./application/general/links";
import {initLoadingScreen} from "./application/general/loading-screen";
import {initMasthead} from "./application/general/masthead";
import {initShareLinks} from "./application/general/share-links";
import {initLogosSliders} from "./application/blocks/wv-logo-slider";
import {CardsCoverImagesObserver} from "./application/observers/CardsCoverImagesObserver";
import {SectionObserver} from "./application/observers/SectionObserver";
import {StaggeredGridObserver} from "./application/observers/StaggeredGridObserver";
import {StickyObserver} from "./application/observers/StickyObserver";
import {TransitionObserver} from "./application/observers/TransitionObserver";
import {Overlay} from "./application/Overlay";
import {ScrollIndicator} from "./application/ScrollIndicator";
import {CallToActionsSlider} from "./application/sliders/templates/CallToActionsSlider";
import {RelatedPostsSlider} from "./application/sliders/templates/RelatedPostsSlider";
import {TabNavigation} from "./application/TabNavigation";
import {PluginCaseStudies} from "./plugins/dierck-group-case-studies/PluginCaseStudies";
import {PluginCompany} from "./plugins/dierck-group-company/PluginCompany";
import {PluginEvents} from "./plugins/dierck-group-events/PluginEvents";
import {PluginPartner} from "./plugins/dierck-group-partner/PluginPartner";
import {initVideos} from "./application/general/videos";

(function(): void {

	// General
	// ---------------------------------------------------------------------------------------------------------
	initLoadingScreen();
	initMasthead();
	initLinks();
	initShareLinks();
	initVideos();

    // Layout (General)
    // ---------------------------------------------------------------------------------------------------------
    // Layout: Scroll Indicator
    ScrollIndicator.init();
    // Layout: Overlay
	Overlay.init();
	// Layout: A11y Controls
	A11yControls.init();
	// Layout: Call To Actions
	CallToActionsSlider.init();

	// Blocks
	// ---------------------------------------------------------------------------------------------------------
	initAccordionBlocks();
	initAnimatedTextsBlocks();
	initCounterBlocks();
	initLogosSliders();
	initNavigatedContentBlocks();
	initPostsTeasers();
	initVideoBlocks();

	TabNavigation.init();

	// Templates
	// ---------------------------------------------------------------------------------------------------------

	// Template: Post
	RelatedPostsSlider.init();

    // Blocks (Observers)
    // ---------------------------------------------------------------------------------------------------------

    // Block: block--has-transition
    TransitionObserver.init();
    // Block: wv-section
    SectionObserver.init();
    // Block: wv-cards-cover-image
    CardsCoverImagesObserver.init();
    // Block: wv-staggered-columns
    StaggeredGridObserver.init();

	StickyObserver.init();

    // Blocks (Slider)
    // ---------------------------------------------------------------------------------------------------------

    // Block: wv-cards-cover-image
    CardsCoverImageSlider.init();
    // Block: wv-cards-slider
    CardsSlider.init();
    // Block: wv-steps-slider
    StepsSlider.init();
    // Block: wv-testimonials-slider
    TestimonialsSlider.init();

    // Blocks (Other)
    // ---------------------------------------------------------------------------------------------------------

    // Block: wv-cards-scroll-container
    CardsScrollContainer.init();

    // Block: wv-service-wheel
    const serviceWheelBlocks: NodeListOf<HTMLDivElement> = document.querySelectorAll( '.wv-service-wheel' );
    serviceWheelBlocks.forEach(blockEl => {
        const serviceWheelInstance = Object.create(ServiceWheel);
        serviceWheelInstance.init(blockEl);
    });


	// Plugins
	// ---------------------------------------------------------------------------------------------------------
	PluginCaseStudies.init();
	PluginCompany.init();
	PluginEvents.init();
	PluginPartner.init();
})();
